import React from 'react';
import { Col, Row, Spin, Typography } from 'antd';
import "../layout/layout.scss";

const { Text } = Typography;

const ContentLoader = () => {    

    return (
        <Row>
            <Col className="loader-content" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                <Spin size='default'/>
                <Text style={{ marginTop: 20 }}>{"Loading..."}</Text>
            </Col>
        </Row>
    );
}
export default ContentLoader;